import { render, staticRenderFns } from "./ThePlayerSelector.vue?vue&type=template&id=04a709e4&scoped=true"
import script from "./ThePlayerSelector.vue?vue&type=script&lang=js"
export * from "./ThePlayerSelector.vue?vue&type=script&lang=js"
import style0 from "./ThePlayerSelector.vue?vue&type=style&index=0&id=04a709e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a709e4",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QIcon,QBtn});
